import React from 'react';
import getSubPage from './utils/getSubPage';
import { checkQueryEqual, pushState } from './utils';
// 所有的store都在这里定义
class RouterWebSdk {
    store = {};
    titleModifyFn;
    init(routerConfigList, notFoundConfig, titleModifyFn) {
        // 校验config、notFoundConfig是否符合规范
        const checkRouterConfig = (configInfo, isCheckBundle = true) => {
            if (isCheckBundle && !configInfo.bundle) {
                throw new Error('router config bundle is required');
            }
            if (!configInfo.fullPath) {
                throw new Error('router config  fullPath is required');
            }
            if (!configInfo.pageId) {
                throw new Error(' router config  pageId is required');
            }
        };
        routerConfigList.forEach((item) => checkRouterConfig(item, false));
        checkRouterConfig(notFoundConfig);
        this.titleModifyFn = titleModifyFn || undefined;
        // 初始化store
        this.store['routerConfigList'] = routerConfigList;
        this.store['notFoundConfig'] = notFoundConfig;
    }
    useRouterFederated(loadingComponent = null, shouldOnPopCallback = false) {
        const [currContent, setCurrContent] = React.useState(null);
        // 声明为 as IContent[] 类型
        const [contentList, setContentList] = React.useState([]);
        const [activeIndex, setActiveIndex] = React.useState(0);
        const [activeConfig, setActiveConfig] = React.useState({});
        const updatePage = (target, extra = {}, colse = false) => {
            const { routerQuery = {}, tryRefresh = false, pageTitle = '', shouldPushState = true, } = extra;
            const routerConfig = this.store.routerConfigList?.find((config) => {
                if (config.pageId === target) {
                    return true;
                }
                if (target === '/' && config.fullPath === target) {
                    return true;
                }
                // 处理掉 path 结尾有/的情况
                const formatPath = target.replace(/[#?]+.*/, '').replace(/\/$/, '');
                if (config.fullPath === formatPath) {
                    return true;
                }
                return false;
            });
            if (!routerConfig) {
                console.error('not found this page,please input correct pageId');
                window.router.go(this.store.notFoundConfig?.pageId);
                return;
            }
            const { bundle, name, fullPath, pageId } = routerConfig;
            // 判断是否应该在 contentList 中，并且查找出对应的 index 和 instance
            const contentInstanceIndex = contentList.findIndex((item) => item.pageId === pageId || item.fullPath === fullPath);
            const contentInstance = contentList[contentInstanceIndex];
            // 关闭之后，回到第一个页面
            if (colse) {
                const colseIndex = contentList.findIndex((item) => item.pageId === pageId);
                if (colseIndex !== activeIndex) {
                    // 关闭的不是当前选中的页面
                    const newContentList = contentList.filter((item) => item.pageId !== pageId);
                    setContentList(newContentList);
                    // 如果 index 大于当前选中的 index，不需要重新选中，选中的 index 不变
                    if (colseIndex < activeIndex) {
                        setActiveIndex(activeIndex - 1);
                        setCurrContent(newContentList[activeIndex - 1].ContentNode);
                    }
                }
                else {
                    // 关闭的是当前选中的页面，需要重新选中，选中第一个
                    const newContentList = contentList.filter((item) => item.pageId !== pageId);
                    setContentList(newContentList);
                    setActiveIndex(0);
                    setCurrContent(newContentList[0].ContentNode);
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { ContentNode: _, ...activeConfig } = newContentList[0];
                    setActiveConfig(activeConfig);
                }
                return;
            }
            if (shouldPushState) {
                pushState(fullPath, this.titleModifyFn && this.titleModifyFn(pageTitle || name), routerQuery || {});
            }
            // 已经有历史的记录情况之下
            if (contentInstance) {
                const { routerQuery: instanceQuery } = contentInstance;
                // 根据
                const isQueryEqual = checkQueryEqual(instanceQuery || {}, routerQuery || {});
                // 参数相同的情况下，不需要重新加载
                if (isQueryEqual && !tryRefresh) {
                    setActiveIndex(contentInstanceIndex);
                    setCurrContent(contentInstance.ContentNode);
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { ContentNode: _, ...activeConfig } = contentInstance;
                    setActiveConfig(activeConfig);
                }
                // 参数相同的情况下，还是需要重新加载
                if ((isQueryEqual && tryRefresh) || !isQueryEqual) {
                    const contentComponent = React.memo(getSubPage(bundle, loadingComponent));
                    const tag = new Date().getTime();
                    const newContentList = contentList.map((item) => {
                        if (item.pageId === pageId) {
                            return {
                                pageId: pageId,
                                fullPath,
                                tag,
                                ContentNode: contentComponent,
                                routerQuery: routerQuery || {},
                                pageTitle,
                                tryRefresh,
                            };
                        }
                        return item;
                    });
                    setContentList(newContentList);
                    setActiveIndex(contentInstanceIndex);
                    setCurrContent(contentComponent);
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { ContentNode: _, ...activeConfig } = newContentList[contentInstanceIndex];
                    setActiveConfig(activeConfig);
                }
            }
            else {
                // 没有历史记录的情况下
                const tag = new Date().getTime();
                const contentComponent = React.memo(getSubPage(bundle, loadingComponent));
                const activeConfig = {
                    pageId: pageId,
                    fullPath,
                    tag,
                    routerQuery: routerQuery || {},
                    pageTitle,
                    tryRefresh,
                };
                setContentList([
                    ...contentList,
                    {
                        ...activeConfig,
                        ContentNode: contentComponent,
                    },
                ]);
                setActiveIndex(contentList.length);
                setCurrContent(contentComponent);
                setActiveConfig(activeConfig);
            }
        };
        window.router = {
            go: (target, { routerQuery = {}, tryRefresh = false, pageTitle = '', shouldPushState = true, } = {}) => {
                updatePage(target, {
                    routerQuery,
                    tryRefresh,
                    pageTitle,
                    shouldPushState,
                });
            },
            refresh: (target, { routerQuery = {}, pageTitle = '' } = {}) => {
                updatePage(target, {
                    routerQuery,
                    tryRefresh: true,
                    pageTitle,
                    shouldPushState: false,
                });
            },
            close: (target) => {
                updatePage(target, {
                    routerQuery: {},
                    tryRefresh: false,
                    shouldPushState: false,
                    pageTitle: '',
                }, true);
            },
            openNewTab: (target, { routerQuery = {}, hash = '', openType = '', options = '', isThirdPath = true, } = {}) => {
                if (isThirdPath) {
                    window.open(target, openType, options);
                    return;
                }
                const routerConfig = this.store.routerConfigList?.find((config) => {
                    if (config.pageId === target) {
                        return true;
                    }
                    // 处理掉 path 结尾有/的情况
                    const formatPath = target.replace(/[#?]+.*/, '').replace(/\/$/, '');
                    if (config.fullPath === formatPath) {
                        return true;
                    }
                    return false;
                });
                if (!routerConfig) {
                    console.error('not found this page,please input correct pageId');
                    window.router.go(this.store.notFoundConfig?.pageId);
                    return;
                }
                // 构建新的url，加入参数和 hash
                const openURL = new URL(location.origin + routerConfig.fullPath);
                Object.keys(routerQuery).forEach((key) => {
                    openURL.searchParams.append(key, routerQuery[key]);
                });
                openURL.hash = hash;
                window.open(openURL, openType, options);
            },
        };
        React.useEffect(() => {
            const handbackForward = (e) => {
                e.preventDefault();
                e.stopPropagation();
                const currFullPath = window.location.pathname;
                const currRouterConfig = this.store.routerConfigList?.find((config) => config.fullPath === currFullPath);
                if (!currRouterConfig) {
                    window.router.go(this.store.notFoundConfig?.pageId);
                    return;
                }
                const { pageId } = currRouterConfig;
                updatePage(pageId, { routerQuery: e.state, shouldPushState: false });
            };
            window.addEventListener('popstate', (e) => {
                if (shouldOnPopCallback) {
                    handbackForward(e);
                }
            });
            return () => {
                window.removeEventListener('popstate', handbackForward);
            };
            // 还需要监听 router 点击路由变化的，点击前进后退的情况
        }, []);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return {
            contentNode: currContent,
            contentNodeList: contentList,
            activeConfig: Object.keys(activeConfig).length ? activeConfig : null,
        };
    }
}
export default RouterWebSdk;
